// extracted by mini-css-extract-plugin
module.exports = {"root":"_0fada4","mainButton":"_625423","btnCompare":"_05fa1f","compareSave":"_e05f8b","headerWrapper":"_4fefb8"};